<template>
    <div class="home-app-store">
        <div class="app-store-top">
            <div class="app-store-title">
                中色云工业应用商店，专为企业用户打造
            </div>
            <div class="category-wrap">

                <template v-for="(item, index) in leftList">
                    <div class="category-Item active" :key="item.id" v-if="activateIndex === index"
                        @click="handleSelect(item, index)">
                        {{ item.dictName }}
                        <div class="line" />
                    </div>
                    <div class="category-Item" :key="item.id" v-else @click="handleSelect(item, index)">
                        {{ item.dictName }}
                    </div>
                </template>
                <div class="more" @click="windOpen">查看全部产品 <i class="el-icon-arrow-right" /></div>
            </div>
        </div>
        <div class="product-wrap">
            <card v-for="item in rightList" :key="item.applicationID" :list="item" />
        </div>
    </div>
</template>
<script>
import card from './card.vue'
import { getAppHomePageList, appClassifyList } from "@/api/index.js";
export default {
    components: {
        card,
    },
    data() {
        return {
            activateIndex: 0,
            leftList: [],
            rightList: [],
            seachParams: {
                pageNo: 1,
                pageSize: 8,
                appClassify: null,
                appTitle: null,
            },
        };
    },
    mounted() {
        this.getAppList();
        this.getDictsByCodeList();
    },
    methods: {
        // 获取引用商店类型
        async getDictsByCodeList() {
            let { code, data, } = await appClassifyList();
            if (code == 0) {
                this.leftList = data.content.dictList;
                let index = this.leftList.findIndex(item => item.dictCode === 'mechanism_model');
                this.leftList.splice(index,1)
                this.leftList.unshift({
                    dictCode: null,
                    dictName: "推荐",
                });
            }
        },
        windOpen() {
            window.open(window.DOMAIN_CONFIG.store);
        },
        async getAppList() {
            let { code, data, } = await getAppHomePageList(this.seachParams);
            if (code == 0) {
                this.rightList = (data.items || []).slice(0, 8);
            }
        },
        handleSelect(item, index) {
            this.activateIndex = index;
            this.seachParams.appClassify = item.dictCode;
            this.getAppList();
        },
    },
};
</script>
<style lang="less" scoped>
.home-app-store {
    width: 100%;
    background: #F3F5F8;
    padding-bottom: 80px;

    .app-store-top {
        background: #FFFFFF;
        padding-top: 84px;
        padding-bottom: 21px;
        box-shadow: 0px 0px 12px 0px rgba(229, 235, 243, 1);
        position: relative;

        .app-store-title {
            font-family: PingFangSC-Regular;
            font-size: 36px;
            color: #2A313B;
            letter-spacing: 0;
            text-align: center;
            line-height: 36px;
            font-weight: 400;
            margin: auto;
            margin-bottom: 59px;
        }

        .category-wrap {
            width: 1280px;
            height: 22px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            position: relative;

            .category-Item {
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #000000;
                font-weight: 400;
                margin-right: 20px;
                position: relative;
                cursor: pointer;
                padding: 0 10px;
            }

            .active {
                color: #005FE1;
                font-weight: 500;
            }

            .line {
                width: 100%;
                height: 4px;
                background: #005FE1;
                position: absolute;
                left: 0;
                top: 27px;
            }

            .more {
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #005FE1;
                text-align: right;
                font-weight: 400;
                position: absolute;
                right: 0;
                cursor: pointer;

                .el-icon-arrow-right {
                    font-weight: bold;
                }
            }
        }
    }

    .product-wrap {
        width: 1280px;
        margin: auto;
        margin-top: 40px;
        display: flex;
        flex-wrap: wrap;
    }

}
</style>